import React from 'react';

export default function Logo({ dark = false, className = '' }) {
  const titleColor = dark ? '#ffffff' : '#0f172a';
  const subColor = dark ? '#94a3b8' : '#475569';
  const barColor = '#ea580c';

  return (
    <div className={`inline-flex items-center gap-3 ${className}`}>
      {/* Icon: orange square + white A with orange crossbar */}
      <svg width="38" height="38" viewBox="0 0 46 46" fill="none" xmlns="http://www.w3.org/2000/svg" style={{ flexShrink: 0 }}>
        <rect width="46" height="46" rx="10" fill="#ea580c"/>
        <path d="M23 8 L38 37 H32 L28.5 29 H17.5 L14 37 H8 Z" fill="white"/>
        <rect x="19" y="23" width="10" height="4" fill="#ea580c"/>
      </svg>
      {/* Wordmark */}
      <div style={{ display: 'flex', flexDirection: 'column', justifyContent: 'center' }}>
        <div style={{
          fontFamily: 'Inter, sans-serif',
          fontWeight: 900,
          fontSize: 18,
          lineHeight: 1,
          color: titleColor,
          letterSpacing: '2px',
        }}>
          APEX
        </div>
        <div style={{ width: '100%', height: 2, background: barColor, margin: '4px 0 3px' }} />
        <div style={{
          fontFamily: 'Inter, sans-serif',
          fontWeight: 300,
          fontSize: 9.5,
          color: subColor,
          letterSpacing: '2.5px',
          textTransform: 'uppercase',
        }}>
          Rénovation
        </div>
      </div>
    </div>
  );
}
